import { createSelector } from 'reselect'
import { sum } from 'lib/array/arrayUtils'
import getLoyaltyPurchasePointsItemViews from '../itemViews/getLoyaltyPurchasePointsItemViews'
import { knownPriceBreakdownTitle } from 'checkout/constants/priceBreakdownTitles'
import { getCurrentIntl } from 'i18n/util/currentIntl'

const getLoyaltyPurchasePointsBreakdownView = createSelector(
  (state: App.State) => getLoyaltyPurchasePointsItemViews(state),
  (viewWithStatus): App.WithDataStatus<Array<App.Checkout.PriceBreakdownView>> => {
    if (viewWithStatus.data.length === 0) {
      return { hasRequiredData: viewWithStatus.hasRequiredData, data: [] }
    }

    const intl = getCurrentIntl()
    const basePoints = sum(viewWithStatus.data, view => view.item.points)
    const bonusPoints = sum(viewWithStatus.data, view => view.item.bonusPoints)
    const basePointsLine = intl.formatMessage(
      {
        id: 'IXv31axyPyRJjOsnuLyb',
        defaultMessage: '{points, number} pts',
        description: 'Buy-points right-column summary subline showing the points being purchased',
      },
      { points: basePoints },
    )
    const bonusPointsLine = bonusPoints > 0 ? intl.formatMessage(
      {
        id: '5VdSaPIguI_nJiaXNImg',
        defaultMessage: '+{points, number} bonus pts',
        description: 'Buy-points right-column summary subline showing extra promotional bonus points (rendered in green)',
      },
      { points: bonusPoints },
    ) : undefined

    const breakdownView: App.Checkout.PriceBreakdownView = {
      title: knownPriceBreakdownTitle('pointsToPurchase'),
      additionalInfoText: [basePointsLine],
      ...(bonusPointsLine && { additionalInfoPromotion: [bonusPointsLine] }),
      items: [],
      price: sum(viewWithStatus.data, view => view.totals.price),
      memberPrice: 0,
      alwaysShowItemPrice: true,
    }

    return {
      hasRequiredData: viewWithStatus.hasRequiredData,
      data: [breakdownView],
    }
  },
)

export default getLoyaltyPurchasePointsBreakdownView
